/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import PropTypes from 'prop-types';
import PersonIcon from 'material-ui/svg-icons/social/person';
import Popover from 'material-ui/Popover';
import Menu from 'material-ui/Menu';
import MenuItem from 'material-ui/MenuItem';
import { withRouter } from 'react-router-dom';
import { Environment } from 'relay-runtime';
import UserChangePassword from '../UserChangePassword';

import '../ui/popover.css';
import './userInfo.css';

const styleMenuItem = {
    fontSize: 14,
    minHeight: 20,
    lineHeight: '40px',
};

const propTypes = {
    info: PropTypes.shape({ name: PropTypes.string }),
    onLogout: PropTypes.func.isRequired,
    history: PropTypes.object,
    relay: PropTypes.shape({
        environment: PropTypes.instanceOf(Environment).isRequired
    }),
};

class UserInfo extends React.Component {
    static defaultProps = {
        info: { name: '' },
        history: {},
    };

    constructor(props) {
        super(props);

        this.state = {
            info: props.info,
            open: false,
            openMenu: false,
        };
    }

    componentWillReceiveProps(nextProps) {
        this.setState({ info: nextProps.info });
    }

    onChangePassword = () => {
        this.setState({ open: false });
    };

    handleShowPopup = (event) => {
        event.preventDefault();
        this.setState({ open: true });
        this.handleCloseMenu();
    };

    handleCloseMenu = () => {
        this.setState({
            openMenu: false,
        });
    };

    handleOpenMenu = (event) => {
        event.preventDefault();

        this.setState({
            openMenu: true,
            anchorEl: event.currentTarget,
        });
    };

    logout() {
        this.props.onLogout();
        this.props.history.push('/');
        this.setState({ info: {} });
        setTimeout(() => {
            this.setState({ info: {} });
        }, 100);
    }

    render() {
        const menuItem = [
            {
                name: 'Сменить пароль',
                handle: this.handleShowPopup,
            },
            {
                name: 'Выйти',
                handle: this.logout.bind(this),
            },
        ];
        if (this.state.info && Object.prototype.hasOwnProperty.call(this.state.info, 'name')) {
            return (
                <div className="user-info">
                    <UserChangePassword
                        relay={this.props.relay}
                        open={this.state.open}
                        onChange={this.onChangePassword}
                    />

                    <a href="#" className="user-info--link" onClick={this.handleOpenMenu}>
                        <PersonIcon color="#777777" className="user-info--icon" />
                        <span className="user-info--name">{this.state.info.name}</span>
                    </a>

                    <Popover
                        style={{
                            boxShadow: '0 2px 4px rgba(0, 0, 0, .5)',
                            maxWidth: 200,
                        }}
                        className="popover_arrow"
                        open={this.state.openMenu}
                        anchorEl={this.state.anchorEl}
                        anchorOrigin={{ horizontal: 'middle', vertical: 'bottom' }}
                        targetOrigin={{ horizontal: 'left', vertical: 'top' }}
                        onRequestClose={this.handleCloseMenu}
                    >
                        <Menu>
                            {
                                menuItem.map((item) => (
                                    <MenuItem
                                        key={item.name}
                                        innerDivStyle={{ padding: '0 21px', maxWidth: 160 }}
                                        style={styleMenuItem}
                                        primaryText={item.name}
                                        onClick={item.handle}
                                    />
                                ))
                            }
                        </Menu>
                    </Popover>
                </div>
            );
        }
        return (<div />);
    }
}

UserInfo.propTypes = propTypes;

export default withRouter(UserInfo);



// WEBPACK FOOTER //
// src/components/userInfo/UserInfo.js